"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSendCustomerAttributes = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _react = require("react");
var _constantsGenerated = require("../constants-generated");
var _webMessengerContext = require("../contexts/webMessengerContext");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
const useSendCustomerAttributes = () => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    customerId,
    isAnonymousUser,
    token
  } = (0, _auth.useToken)();
  const {
    isScriptLoaded
  } = (0, _webMessengerContext.useWebMessenger)();
  const localLogger = (0, _logger.useLogger)('useSendCustomerAttributes');
  const [attributesSent, setAttributesSent] = (0, _react.useState)(false);
  const {
    data,
    error
  } = (0, _fetching.useGraphqlQuery)({
    query: _queriesNet.customerQuery,
    url: graphQlNetUrl,
    headers: (0, _fetching.getHeaders)({
      customerId,
      language,
      sourceAppName: _constantsGenerated.PACKAGE_NAME,
      tenant,
      token
    }),
    skip: (0, _utils.shouldSkipGraphqlQuery)({
      isAnonymousUser,
      isScriptLoaded
    }),
    swrConfig: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  if (error) {
    localLogger.error(new Error('useGraphqlQuery customerQuery', {
      cause: error
    }));
  }
  (0, _react.useEffect)(() => {
    if (isScriptLoaded && (data != null || error != null || isAnonymousUser)) {
      (0, _utils.sendCustomerData)({
        language,
        data,
        tenant
      });
      setAttributesSent(true);
    }
  }, [isScriptLoaded, data, error, language, tenant, isAnonymousUser]);
  return {
    attributesSent
  };
};
exports.useSendCustomerAttributes = useSendCustomerAttributes;
